export default "__VITE_ASSET__B0FW0Nqa__"